export const TOOLS = [
  {
    id: "social_post",
    label: "Publicaciones para redes",
    short: "Redes",
    desc: "Textos listos para Instagram, Facebook o TikTok con hashtags.",
    fields: [
      { name: "business_type", label: "Tipo de negocio", placeholder: "Ej.: pastelería artesanal" },
      { name: "product", label: "Producto o servicio a promocionar", placeholder: "Ej.: tartas personalizadas para cumpleaños" },
      { name: "platform", label: "Red social", type: "select", options: ["Instagram", "Facebook", "TikTok"] },
      { name: "tone", label: "Tono", type: "select", options: ["Cercano y divertido", "Profesional y elegante", "Inspirador", "Oferta con urgencia"] },
    ],
  },
  {
    id: "marketing_ideas",
    label: "Ideas de marketing",
    short: "Plan",
    desc: "Un mini plan de 30 días para conseguir clientas.",
    fields: [
      { name: "business_type", label: "Tipo de negocio", placeholder: "Ej.: centro de estética" },
      { name: "goal", label: "¿Qué quieres conseguir?", placeholder: "Ej.: llenar la agenda de lunes a miércoles" },
      { name: "audience", label: "Tu clienta ideal y zona", placeholder: "Ej.: mujeres de 30-50 años en Madrid" },
      { name: "budget", label: "Presupuesto mensual", type: "select", options: ["0 € (solo orgánico)", "Menos de 100 €", "100 – 300 €", "Más de 300 €"] },
    ],
  },
  {
    id: "product_description",
    label: "Descripciones de producto",
    short: "Producto",
    desc: "Textos que venden para tu tienda online o WhatsApp Business.",
    fields: [
      { name: "product_name", label: "Producto o servicio", placeholder: "Ej.: velas aromáticas de soja" },
      { name: "features", label: "Características principales", placeholder: "Ej.: hechas a mano, 40 h de duración, aroma vainilla" },
      { name: "audience", label: "¿Para quién es?", placeholder: "Ej.: personas que buscan un regalo bonito" },
      { name: "channel", label: "¿Dónde la vas a usar?", type: "select", options: ["Tienda online", "WhatsApp Business", "Instagram Shopping", "Marketplace (Etsy, Amazon)"] },
    ],
  },
];

export const IMAGE_TOOL = {
  id: "social_image",
  label: "Imágenes para redes",
  desc: "Fotos y escenas para tus publicaciones, creadas con IA. Gratis con tu email: 3 imágenes al día.",
  fields: [
    { name: "business_type", label: "Tipo de negocio", placeholder: "Ej.: pastelería artesanal" },
    { name: "subject", label: "¿Qué quieres mostrar?", placeholder: "Ej.: tarta de fresas sobre una mesa de madera" },
    { name: "style", label: "Estilo", type: "select", options: ["Foto realista luminosa", "Elegante y minimalista", "Colorida y alegre", "Ilustración moderna"] },
    { name: "format", label: "Formato", type: "select", options: ["Cuadrada (post)", "Vertical (historia o reel)"] },
  ],
};

export const MODELS = [
  { id: "claude", label: "Claude Sonnet 5.5" },
  { id: "gpt", label: "GPT 5.5" },
  { id: "gemini", label: "Gemini 3 Flash" },
];
